import "./pdp-experience-switcher-v4.scss";

const initPrintPressSelection = () => {
  const $container = document.querySelector(".js-print-press-selection");
  if (!$container) return;

  const $yesButton = $container.querySelector(".js-print-press-yes");
  const $noButton = $container.querySelector(".js-print-press-no");

  const updateSelection = selection => {
    $container.dataset.selected = selection;

    if (selection === "yes") {
      // Update button styles for Yes selection
      $yesButton.classList.remove("bg-white", "text-blue-700", "border", "border-blue-700");
      $yesButton.classList.add("bg-blue-700", "text-white!");

      $noButton.classList.remove("bg-blue-700", "text-white!");
      $noButton.classList.add("bg-white", "text-blue-700", "border", "border-blue-700");

      // The .js-scroll-to-design class on the Yes button will handle scrolling to design section
    } else {
      // Update button styles for No selection
      $noButton.classList.remove("bg-white", "text-blue-700", "border", "border-blue-700");
      $noButton.classList.add("bg-blue-700", "text-white!");

      $yesButton.classList.remove("bg-blue-700", "text-white!");
      $yesButton.classList.add("bg-white", "text-blue-700", "border", "border-blue-700");
    }
  };

  // Attach event listeners
  $yesButton?.addEventListener("click", () => updateSelection("yes"));
  $noButton?.addEventListener("click", () => updateSelection("no"));

  // Set default state to "No"
  updateSelection("no");
};

export default () => {
  initPrintPressSelection();
};
